import LegalLayout from "./LegalLayout"

export default function PolitiqueConfidentialite() {
  return (
    <LegalLayout>

      <h2>Données collectées</h2>
      <p>
        Le site collecte uniquement les données suivantes :
      </p>
      <ul>
        <li>Nom</li>
        <li>Prénom</li>
        <li>Numéro de téléphone</li>
        <li>Remarques liées à la commande</li>
      </ul>

      <h2>Finalité</h2>
      <p>
        Les données sont utilisées uniquement pour le traitement des commandes
        et la prise de contact avec le client si nécessaire.
      </p>

      <h2>Transmission</h2>
      <p>
        Les données sont envoyées par email à la Friterie de Lalaing.
        Elles ne sont transmises à aucun tiers.
      </p>

      <h2>Conservation</h2>
      <p>
        Les données sont conservées uniquement le temps nécessaire au traitement
        des commandes, puis supprimées manuellement.
      </p>

      <h2>Base légale</h2>
      <p>
        Le traitement est basé sur l’exécution d’une commande client.
      </p>

      <h2>Vos droits</h2>
      <p>
        Conformément au RGPD, vous pouvez demander l’accès, la rectification
        ou la suppression de vos données en écrivant à :
      </p>

      <p>
        <strong>lalaing@abjmnets.com</strong>
      </p>

      <h2>Cookies</h2>
      <p>
        Le site n’utilise pas de cookies publicitaires ni de tracking.
        Certaines iframes externes peuvent toutefois déposer des cookies tiers.
      </p>

    </LegalLayout>
  )
}